module.exports = __webpack_public_path__ + "img/timeline.965e83a4.png";